import type { WithId } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type { EmitPayload, SubscribePayload } from './types'

export const SocketActions = {
  init: createAction('INIT_SOCKET'),
  close: createAction('CLOSE_SOCKET'),
  subscribe: createAction<SubscribePayload>('SUBSCRIBE_SOCKET'),
  unsubscribe: createAction<WithId>('UNSUBSCRIBE_SOCKET'),
  emit: createAction<EmitPayload>('EMIT_SOCKET'),
  updateProject: createAction('UPDATE_PROJECT_BY_SOCKET'),
}
